module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((_vm.desistencias && _vm.desistencias.length > 0) && !_vm.desistenciasLoading) ? _c('div', {
    staticClass: "wrapper-sm no-padder m-b"
  }, [_c('email-view', {
    ref: "emailView"
  }), _vm._v(" "), _c('div', {
    staticClass: " bg-black"
  }, [_c('div', {
    staticClass: "wrapper-sm bg-dark font-bold text-uppercase"
  }, [_vm._v("Desistências")]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table table-black",
    attrs: {
      "id": "tableLances"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.desistencias), function(venda) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(venda.data.date).format('L')) + " " + _vm._s(_vm.moment(venda.data.date).format('LTS')))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'arrematantes.visualizar',
          params: {
            id: venda.arrematante.id
          }
        }
      }
    }, [_vm._v(_vm._s(venda.arrematante.apelido) + "\n            ")])], 1), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(venda.dados.lote.valorArremate)))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'lotes.visualizar',
          params: {
            id: venda.dados.lote.id
          }
        }
      }
    }, [_vm._v(_vm._s(venda.dados.lote.numero) + "\n            ")]), _vm._v(" "), (venda.dados.lote.leilao) ? _c('span', [_vm._v("do leilão de " + _vm._s(_vm.moment(venda.dados.lote.leilao.dataAbertura.date).format('L LTS')))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(venda.status === 1) ? _c('div', [_vm._v("Aviso registro órgãos de proteção")]) : (venda.status === 2) ? _c('div', [_vm._v("Dívida inscrita")]) : (venda.status === 100) ? _c('div', [_vm._v("Dívida paga")]) : (venda.status === 101) ? _c('div', [_vm._v(" Dívida cancelada")]) : _c('div', [_vm._v("Cobrança de multa")])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-xs bg-white",
      on: {
        "click": function($event) {
          return _vm.cobrarDesistencia(venda.id)
        }
      }
    }, [_vm._v("Cobrar")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-warning",
      on: {
        "click": function($event) {
          return _vm.informarNegativacao(venda.id)
        }
      }
    }, [_vm._v("Alerta Negativação")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          return _vm.negativar(venda.id)
        }
      }
    }, [_vm._v("Negativar")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-success",
      on: {
        "click": function($event) {
          return _vm.informarNegativacao(venda.id)
        }
      }
    }, [_vm._v("Pagar")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-info",
      on: {
        "click": function($event) {
          return _vm.informarNegativacao(venda.id)
        }
      }
    }, [_vm._v("Cancelar")])])])
  }), _vm._v(" "), ((!_vm.desistencias || _vm.desistencias.length === 0) && !_vm.desistenciasLoading) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.desistenciasLoading) ? _c('tr', [_vm._m(2)]) : _vm._e()], 2)])])])], 1) : _c('div', [(_vm.desistenciasLoading) ? _c('div', [_vm._v("Verficando se há desistências...")]) : _c('div')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Apelido")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Lote")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "no-borders",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Nenhuma desistência")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "no-borders text-center",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner m-t fa-2x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bbdf5be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/includes/Desistencias.vue
// module id = 831
// module chunks = 2